import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Zap, Loader2, ArrowLeft, MailCheck } from "lucide-react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F4F6F8] px-6">
      <div className="w-full max-w-sm">
        <div className="mb-6 flex items-center gap-2.5">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-brand">
            <Zap className="h-5 w-5 text-white" />
          </div>
          <span className="font-display text-lg font-bold text-slate-900">ESSECI E-LIGHT</span>
        </div>

        {sent ? (
          <div className="rounded-xl border border-slate-200 bg-white p-6 text-center" data-testid="forgot-success">
            <div className="mx-auto mb-3 flex h-12 w-12 items-center justify-center rounded-full bg-emerald-50">
              <MailCheck className="h-6 w-6 text-emerald-600" />
            </div>
            <h2 className="font-display text-lg font-bold text-slate-900">Controlla la tua email</h2>
            <p className="mt-2 text-sm text-slate-500">
              Se l'email è registrata, riceverai un link per reimpostare la password.
            </p>
          </div>
        ) : (
          <>
            <h2 className="font-display text-2xl font-bold text-slate-900 tracking-tight">Recupera password</h2>
            <p className="mt-1 text-sm text-slate-500">Ti invieremo un link di reimpostazione.</p>
            {error && (
              <div className="mt-4 rounded-lg border border-rose-200 bg-rose-50 px-3 py-2.5 text-sm text-rose-800" data-testid="forgot-error">
                {error}
              </div>
            )}
            <form onSubmit={handleSubmit} className="mt-6 space-y-4">
              <div className="space-y-1.5">
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" required value={email}
                  onChange={(e) => setEmail(e.target.value)} placeholder="nome@esseci-elight.it"
                  data-testid="forgot-email-input" />
              </div>
              <Button type="submit" disabled={loading} data-testid="forgot-submit-button"
                className="w-full">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Invia link"}
              </Button>
            </form>
          </>
        )}

        <div className="mt-5 text-center">
          <Link to="/login" className="inline-flex items-center gap-1.5 text-sm font-medium text-brand hover:text-brand-strong" data-testid="back-to-login">
            <ArrowLeft className="h-4 w-4" /> Torna al login
          </Link>
        </div>
      </div>
    </div>
  );
}
